export interface FileUploadConfig {
  isNoServerUpload?: boolean;
  accept?: string;
  multiple: boolean;
  sizeLimit: number;
  imageSizeLimit?: number;
  sizeType?: string;
  sizeLimitMessage?: string;
}
